// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.uset2{
  width: 100%;
  height: 1092px !important;
  background-color: white;
  margin: auto;

  text-wrap: wrap;

}
.scroll-container2 {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-x: auto;
  margin: auto;
}
.span22 {
  font-size: 14px;
  font-weight: normal;
  /* line-height: 3px; */
  color: #333333;
  text-wrap: wrap;
  text-align: justify;
}

.top-section2 {
  background-color: #616568;
  text-align: center;
  padding: 4px;
}

.Profile_img2 {
  height: 160px;
  border-radius: 50%;
  border: 2px solid rgb(126, 155, 189);
  margin: 0 auto;
  display: block;

}

.n1 {
  color: white;
  font-size: 40px;
  font-weight: bold;
  margin: 10px 0;
  text-transform: uppercase !important;
}

.sleft2, .sright2 {
  width: 45%;
  padding: 16px 4px;
  float: left;
  padding-left: 26px;
}
.jobtitle2 {
  display: inline-block; /* or display: block; */
}
.jobtitle2::first-letter{
  text-transform: uppercase !important;
}

.line {
  border-left: 2px solid #151b29;
  height:auto!important;
position:inherit;
  float: left;
}

.heading2 {
  font-size: 1.1em;
  margin-bottom: 8px !important;
  color: rgb(82, 78, 78);
margin-top: 12px;
  text-transform: uppercase;
  font-size: 19px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}

.p2 {
  font-weight: normal;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  margin: 2px 0;
  color: #212529;
  word-wrap: break-word;
  text-align: justify;
 
}
.p22 {
  font-weight: normal;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  margin: 2px 0;
  color: #212529;
  display: flex;

}
.title2{
  text-wrap: nowrap;
}
.projectTitle{
  text-wrap: wrap;
}

.db2{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  display: block;
margin-left: 6rem;
  text-wrap: nowrap;
}
.bk2{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  display: block;
  margin-left: -6rem;
}
.button-container2 {
  width: 100%;
  display: flex;
  justify-content: space-between; 
  align-items: center;
  margin: 10px 0; 
  padding: 0 0rem 0 15rem;
}
@media (max-width: 768px) {
  .db2{
    padding-top: 0px !important;
    margin-left: 0px;
  }
  .button-container2 {
    padding: 0px;
  }
  .bk2{
    margin-left: 0rem !important;
  }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .db2{
      padding-top: 0px !important;
      margin-left: 175px;
    }
    .button-container2{
      padding: 0px;
      margin-left: 0px;
      align-items: flex-start;
    }
    .bk2{
      margin-left: 0rem !important;
    }
  }
  @media screen and (max-width: 1187px) and (min-resolution: 110dpi) {
.bk2{
  margin-left: -11rem;
}
  }

#resume-content2 {
  width: 796px; 
  min-width: 730px;
  height: 100%;
  box-shadow: 5px 7px 15px 5px #b9b6b6;
}

@media (max-width: 768px) {
  .uset2 {
    width: 100%; 
    padding: 15px;
  }
.tempcon2{
  max-width: 840px;
}

  .Profile_img2 {
    height: 120px;
    width: 120px;
  }

  /* Candidate Name */
  .n1 {
    font-size: 40px;
  }
  .scroll-container2{

      display: inline-block;
 
  }


  .sleft2, .sright2 {
    width: 100%;
  }

  .line {
    display: none;
  }

  .heading2 {
    font-size: 1.1em;
  }

  .p2 {
    font-size: 14px;
  }


}

@media (max-width: 1024px) {
  .uset2 {
    width: 100%;
    height: 1092px; /* Adjust width for tablet screens */
  }


  .Profile_img2 {
    height: 120px;
    width: 120px;
  }

  .n1 {
    font-size: 40px;
  }

  .sleft2, .sright2 {
    width: 48%; 
  
  }

}

@media (min-width: 430px) and (max-width: 517px) {
  .sleft2, .sright2 {
    width: 48%; 
  }
}

@media (min-width: 410px) and (max-width: 430px) {
  .sleft2, .sright2 {
    width: 48%; 
  }
}

@media (min-width: 1024px) {
  .uset2 {
    width: 796px;
  }

  .Profile_img2 {
    height: 120px;
    width: 120px;
  }

  .n1 {
    font-size: 40px;
  }

  .sleft2, .sright2 {
    width: 45%;
  
  }
}



.footer2 {
  padding: 7px 37px;
  margin-top: 20px;
}

.footer-text2 {
  font-size: 16px;
  color: #6c757d; 
  text-align: end;
  margin-right: 15px;
  margin-bottom: 2px;
}

.footer-link2 {
  color: #007bff; 
  text-decoration: none;
}


`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp2.css"],"names":[],"mappings":";;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;;EAEZ,eAAe;;AAEjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,cAAc;;AAEhB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,qBAAqB,EAAE,uBAAuB;AAChD;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB,gBAAgB;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB,gBAAgB;EACd,yBAAyB;EACzB,eAAe;EACf,4DAA4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,eAAe;EACf,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,mBAAmB;;AAErB;AACA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,eAAe;EACf,aAAa;EACb,cAAc;EACd,aAAa;;AAEf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB,iBAAiB;EACf,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;;EAEA;IACE;MACE,2BAA2B;MAC3B,kBAAkB;IACpB;IACA;MACE,YAAY;MACZ,gBAAgB;MAChB,uBAAuB;IACzB;IACA;MACE,4BAA4B;IAC9B;EACF;EACA;AACF;EACE,mBAAmB;AACrB;EACE;;AAEF;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;EACE,gBAAgB;AAClB;;EAEE;IACE,aAAa;IACb,YAAY;EACd;;EAEA,mBAAmB;EACnB;IACE,eAAe;EACjB;EACA;;MAEI,qBAAqB;;EAEzB;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;EACE;IACE,WAAW;IACX,cAAc,EAAE,oCAAoC;EACtD;;;EAGA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;;EAEZ;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;;EAEZ;AACF;;;;AAIA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["\r\n\r\n.uset2{\r\n  width: 100%;\r\n  height: 1092px !important;\r\n  background-color: white;\r\n  margin: auto;\r\n\r\n  text-wrap: wrap;\r\n\r\n}\r\n.scroll-container2 {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  margin: auto;\r\n}\r\n.span22 {\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  /* line-height: 3px; */\r\n  color: #333333;\r\n  text-wrap: wrap;\r\n  text-align: justify;\r\n}\r\n\r\n.top-section2 {\r\n  background-color: #616568;\r\n  text-align: center;\r\n  padding: 4px;\r\n}\r\n\r\n.Profile_img2 {\r\n  height: 160px;\r\n  border-radius: 50%;\r\n  border: 2px solid rgb(126, 155, 189);\r\n  margin: 0 auto;\r\n  display: block;\r\n\r\n}\r\n\r\n.n1 {\r\n  color: white;\r\n  font-size: 40px;\r\n  font-weight: bold;\r\n  margin: 10px 0;\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.sleft2, .sright2 {\r\n  width: 45%;\r\n  padding: 16px 4px;\r\n  float: left;\r\n  padding-left: 26px;\r\n}\r\n.jobtitle2 {\r\n  display: inline-block; /* or display: block; */\r\n}\r\n.jobtitle2::first-letter{\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.line {\r\n  border-left: 2px solid #151b29;\r\n  height:auto!important;\r\nposition:inherit;\r\n  float: left;\r\n}\r\n\r\n.heading2 {\r\n  font-size: 1.1em;\r\n  margin-bottom: 8px !important;\r\n  color: rgb(82, 78, 78);\r\nmargin-top: 12px;\r\n  text-transform: uppercase;\r\n  font-size: 19px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n}\r\n\r\n.p2 {\r\n  font-weight: normal;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  margin: 2px 0;\r\n  color: #212529;\r\n  word-wrap: break-word;\r\n  text-align: justify;\r\n \r\n}\r\n.p22 {\r\n  font-weight: normal;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  margin: 2px 0;\r\n  color: #212529;\r\n  display: flex;\r\n\r\n}\r\n.title2{\r\n  text-wrap: nowrap;\r\n}\r\n.projectTitle{\r\n  text-wrap: wrap;\r\n}\r\n\r\n.db2{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  display: block;\r\nmargin-left: 6rem;\r\n  text-wrap: nowrap;\r\n}\r\n.bk2{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  display: block;\r\n  margin-left: -6rem;\r\n}\r\n.button-container2 {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between; \r\n  align-items: center;\r\n  margin: 10px 0; \r\n  padding: 0 0rem 0 15rem;\r\n}\r\n@media (max-width: 768px) {\r\n  .db2{\r\n    padding-top: 0px !important;\r\n    margin-left: 0px;\r\n  }\r\n  .button-container2 {\r\n    padding: 0px;\r\n  }\r\n  .bk2{\r\n    margin-left: 0rem !important;\r\n  }\r\n  }\r\n\r\n  @media (min-width: 768px) and (max-width: 1024px) {\r\n    .db2{\r\n      padding-top: 0px !important;\r\n      margin-left: 175px;\r\n    }\r\n    .button-container2{\r\n      padding: 0px;\r\n      margin-left: 0px;\r\n      align-items: flex-start;\r\n    }\r\n    .bk2{\r\n      margin-left: 0rem !important;\r\n    }\r\n  }\r\n  @media screen and (max-width: 1187px) and (min-resolution: 110dpi) {\r\n.bk2{\r\n  margin-left: -11rem;\r\n}\r\n  }\r\n\r\n#resume-content2 {\r\n  width: 796px; \r\n  min-width: 730px;\r\n  height: 100%;\r\n  box-shadow: 5px 7px 15px 5px #b9b6b6;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .uset2 {\r\n    width: 100%; \r\n    padding: 15px;\r\n  }\r\n.tempcon2{\r\n  max-width: 840px;\r\n}\r\n\r\n  .Profile_img2 {\r\n    height: 120px;\r\n    width: 120px;\r\n  }\r\n\r\n  /* Candidate Name */\r\n  .n1 {\r\n    font-size: 40px;\r\n  }\r\n  .scroll-container2{\r\n\r\n      display: inline-block;\r\n \r\n  }\r\n\r\n\r\n  .sleft2, .sright2 {\r\n    width: 100%;\r\n  }\r\n\r\n  .line {\r\n    display: none;\r\n  }\r\n\r\n  .heading2 {\r\n    font-size: 1.1em;\r\n  }\r\n\r\n  .p2 {\r\n    font-size: 14px;\r\n  }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .uset2 {\r\n    width: 100%;\r\n    height: 1092px; /* Adjust width for tablet screens */\r\n  }\r\n\r\n\r\n  .Profile_img2 {\r\n    height: 120px;\r\n    width: 120px;\r\n  }\r\n\r\n  .n1 {\r\n    font-size: 40px;\r\n  }\r\n\r\n  .sleft2, .sright2 {\r\n    width: 48%; \r\n  \r\n  }\r\n\r\n}\r\n\r\n@media (min-width: 430px) and (max-width: 517px) {\r\n  .sleft2, .sright2 {\r\n    width: 48%; \r\n  }\r\n}\r\n\r\n@media (min-width: 410px) and (max-width: 430px) {\r\n  .sleft2, .sright2 {\r\n    width: 48%; \r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .uset2 {\r\n    width: 796px;\r\n  }\r\n\r\n  .Profile_img2 {\r\n    height: 120px;\r\n    width: 120px;\r\n  }\r\n\r\n  .n1 {\r\n    font-size: 40px;\r\n  }\r\n\r\n  .sleft2, .sright2 {\r\n    width: 45%;\r\n  \r\n  }\r\n}\r\n\r\n\r\n\r\n.footer2 {\r\n  padding: 7px 37px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.footer-text2 {\r\n  font-size: 16px;\r\n  color: #6c757d; \r\n  text-align: end;\r\n  margin-right: 15px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.footer-link2 {\r\n  color: #007bff; \r\n  text-decoration: none;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
